import { render, staticRenderFns } from "./thdatahistory.vue?vue&type=template&id=e5812374&scoped=true&"
import script from "./thdatahistory.vue?vue&type=script&lang=ts&"
export * from "./thdatahistory.vue?vue&type=script&lang=ts&"
import style0 from "./thdatahistory.vue?vue&type=style&index=0&id=e5812374&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5812374",
  null
  
)

export default component.exports